/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type ViewInRoomImageCredits_viewInRoomPhoto = {
    readonly credits: string | null;
    readonly " $refType": "ViewInRoomImageCredits_viewInRoomPhoto";
};
export type ViewInRoomImageCredits_viewInRoomPhoto$data = ViewInRoomImageCredits_viewInRoomPhoto;
export type ViewInRoomImageCredits_viewInRoomPhoto$key = {
    readonly " $data"?: ViewInRoomImageCredits_viewInRoomPhoto$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImageCredits_viewInRoomPhoto">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoomImageCredits_viewInRoomPhoto",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "credits",
      "storageKey": null
    }
  ],
  "type": "viewInRoomPhotos",
  "abstractKey": null
};
(node as any).hash = '2319cf38f1b2a3412836e9ab3adde6c1';
export default node;
